<template>
  <div class="menu-content">
    <transition name="fade">
      <div class="menu-list" v-if="listShow" :class="{ 'ui-hide': !uiToggleVar }">
        <ul class="menu-ul">
          <li v-for="(item, index) in menuData" :class="{
              hasChild: item.children,
              active: sceneIndex.first == item.active,
          }" class="menu-item" :key="index" @click="jumpScene(item)">
<!--            <i class="icon" :class="`icon-${item.icon}`"></i>-->
            {{ item.lable }}
            <ul class="menu-child-ul" v-if="index == 1">
              <li class="menu-child-li" :class="{
                active:
                  sceneIndex.first == item.active &&
                  sceneIndex.second == childItem.active,
              }" v-for="(childItem, childIndex) in item.children" :key="childIndex" @click="jumpScene(childItem)"
                :title="childItem.lable">
                {{ childItem.lable }}
              </li>
            </ul>
            <el-row class="menu-child-ul2" v-if="index == 2">
              <el-col :span="6" v-for="(childItem, childIndex) in item.children" :key="childIndex"
                class="menu-child-col">
                <span class="menu-child-li2" :class="{
                  active:
                    sceneIndex.first == item.active &&
                    sceneIndex.second == secChildItem.active,
                }" @click="jumpScene(secChildItem)" :title="secChildItem.lable"
                  v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
                  {{ secChildItem.lable }}
                </span>
              </el-col>

            </el-row>

          </li>
        </ul>

        <!-- <div class="menu-up" @click="listShow = false"></div> -->
      </div>
    </transition>

    <div class="menu-icon" @click="toggleMenu" :class="{ 'ui-hide': !uiToggleVar }"></div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    krpano: "",
    uiToggleVar: true,
    sceneName: "",
  },
  computed: {
    sceneIndex() {
      if (this.sceneName) {
        var nowSceneName = this.sceneName.split("_");
        // console.error('nowSceneName = , nowSceneName', this.sceneName);

        return {
          first:
            nowSceneName[1] == 0
              ? nowSceneName[2] == 0
                ? 0
                : "0.5"
              : nowSceneName[1],
          second: nowSceneName[2],
        };
      } else {
        return {
          first: 0,
          second: "",
        };
      }
    },
  },
  data() {
    return {
      // krpano:"",
      menuData: [
        {
          lable: "序厅",
          index: "0_1_1",
          active: "0.5",
          // icon: "huangguan"
        },
        {
          lable: "中央综合展区",
          index: "",
          disableClick: true,
          active: "1",
          // icon: "circle",
          children: [
            {
              lable: "第一单元\u3000经济建设奋楫扬帆\u3000谱写高质量发展新篇章",
              index: "1_1_0",
              active: "1",
            },
            {
              lable: "第二单元\u3000全面深化改革不断向广度和深度进军\u3000中国特色社会主义制度更加成熟更加定型",
              index: "1_2_1",
              active: "2",
            },
            {
              lable: "第三单元\u3000积极发展全过程人民民主\u3000建设社会主义民主政治",
              index: "1_3_1",
              active: "3",
            },
            {
              lable: "第四单元\u3000着力推进新时代全面依法治国\u3000开辟良法善治新境界",
              index: "1_4_1",
              active: "4",
            },
            {
              lable: "第五单元\u3000坚定文化自信\u3000建设社会主义文化强国",
              index: "1_5_1",
              active: "5",
            },
            {
              lable: "第六单元\u3000全面推进社会建设\u3000不断满足人民美好生活向往",
              index: "1_6_1",
              active: "6",
            },
            {
              lable: "第七单元\u3000坚持人与自然和谐共生\u3000美丽中国建设迈出重大步伐",
              index: "1_7_1",
              active: "7",
            },
            {
              lable: "第八单元\u3000坚持走中国特色强军之路\u3000全面推进国防和军队现代化",
              index: "1_8_1",
              active: "8",
            },
            {
              lable: "第九单元\u3000全面践行总体国家安全观\u3000开创新时代国家安全新局面",
              index: "1_9_1",
              active: "9",
            },
            {
              lable: "第十单元\u3000坚持“一国两制”\u3000推进祖国统一",
              index: "1_10_1",
              active: "10",
            },
            {
              lable: "第十一单元\u3000坚持推动构建人类命运共同体\u3000开创中国特色大国外交新局面",
              index: "1_11_1",
              active: "11",
            },
            {
              lable: "第十二单元\u3000全面从严治党\u3000保持党的生机活力",
              index: "1_12_1",
              active: "12",
            },

          ],
        },
        {
          lable: "地方展区",
          index: "",
          disableClick: true,
          active: "2",
          // icon: "house",
          children: [
            [
              {
                lable: "北京",
                index: "2_1_1",
                active: "1",
              },
              {
                lable: "天津",
                index: "2_2_1",
                active: "2",
              },
              {
                lable: "河北",
                index: "2_3_1",
                active: "3",
              },
              {
                lable: "山西",
                index: "2_4_1",
                active: "4",
              },

              {
                lable: "内蒙古",
                index: "2_5_2",
                active: "5",
              },
              {
                lable: "辽宁",
                index: "2_6_1",
                active: "6",
              },
              {
                lable: "吉林",
                index: "2_7_1",
                active: "7",
              },
              {
                lable: "黑龙江",
                index: "2_8_1",
                active: "8",
              },
              {
                lable: "上海",
                index: "2_9_1",
                active: "9",
              },
            ],
            [
              {
                lable: "江苏",
                index: "2_10_1",
                active: "10",
              },
              {
                lable: "浙江",
                index: "2_11_1",
                active: "11",
              },
              {
                lable: "安徽",
                index: "2_12_1",
                active: "12",
              },
              {
                lable: "福建",
                index: "2_13_1",
                active: "13",
              },
              {
                lable: "江西",
                index: "2_14_1",
                active: "14",
              },
              {
                lable: "山东",
                index: "2_15_1",
                active: "15",
              },
              {
                lable: "河南",
                index: "2_16_1",
                active: "16",
              },
              {
                lable: "湖北",
                index: "2_17_1",
                active: "17",
              },
              {
                lable: "湖南",
                index: "2_18_1",
                active: "18",
              },
            ],
            [
              {
                lable: "广西",
                index: "2_19_1",
                active: "19",
              },
              {
                lable: "广东",
                index: "2_20_1",
                active: "20",
              },
              {
                lable: "香港",
                index: "2_21_1",
                active: "21",
              },
              {
                lable: "澳门",
                index: "2_22_1",
                active: "22",
              },
              {
                lable: "重庆",
                index: "2_23_1",
                active: "23",
              },
              {
                lable: "四川",
                index: "2_24_1",
                active: "24",
              },
              {
                lable: "西藏",
                index: "2_25_1",
                active: "25",
              },
              {
                lable: "陕西",
                index: "2_26_1",
                active: "26",
              },
              {
                lable: "云南",
                index: "2_27_1",
                active: "27",
              },
            ],
            [
              {
                lable: "海南",
                index: "2_28_0",
                active: "28",
              },
              {
                lable: "贵州",
                index: "2_29_1",
                active: "29",
              },
              {
                lable: "甘肃",
                index: "2_30_1",
                active: "30",
              },
              {
                lable: "青海",
                index: "2_31_1",
                active: "31",
              },
              {
                lable: "新疆",
                index: "2_32_1",
                active: "32",
              },
              {
                lable: "宁夏",
                index: "2_33_1",
                active: "33",
              },
            ]

          ],
        },
        {
          lable: "展望展区",
          index: "3_1_1",
          active: "3",
          // icon: "future"
        },
        {
          lable: "室外展区",
          index: "0_0_1",
          active: "0",
          // icon: "building",
          // children:[
          // {
          //     lable: "中国建造",
          //     index: "1_12_1",
          //     active: "0",
          //   },
          //   {
          //     lable: "中国制造",
          //     index: "1_12_1",
          //     active: "0",
          //   },
          //   {
          //     lable: "巡天探海",
          //     index: "1_12_1",
          //     active: "0",
          //   },
          //   {
          //     lable: "坚强柱石",
          //     index: "1_12_1",
          //     active: "0",
          //   },
          // ]
        },
        {
          lable: "互动展区",
          index: "4_1_1",
          active: "4",
          // icon: "hudong",
        
        },
      ],
      listShow: false,
      cityList: [
        [

        ]
      ]
    };
  },
  methods: {
    ...mapMutations('common', ['SET_CLICKED_MAPLIST']),
    toggleMenu() {
      this.listShow = !this.listShow;
    },
    jumpScene(item) {
      if (!item.disableClick) {
        console.log('item==> ', item);
        // 数据插入clickedMapList
        this['SET_CLICKED_MAPLIST'](`scene_${item.index}`)
        this.krpano.call(
          "loadscene(" +
          `scene_${item.index}` +
          ",null, MERGE, BLEND(1.0, easeInCubic));"
        );
      }
    },
  },
  mounted() {
    // this.krpano = document.getElementById("krpanoSWFObject");
  },
  created() { },
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.menu-icon {
  width: 268px;
  height: 67px;
  position: absolute;
  top: 58px;
  left: 50px;
  cursor: pointer;
  background-image: url("../assets/img/menu-icon.png");
  @include background-com();
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  opacity: 1;

  &.ui-hide {
    transform: translateX(-5rem);
    opacity: 0;
  }
}

.menu-list {
  width: 262px;
  height: 278px;
  position: absolute;
  top: 130px;
  left: 50px;
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  opacity: 1;

  &.ui-hide {
    transform: translateX(-5rem);
    opacity: 0;
  }

  @media screen and (max-width: 1380px) {
    & {
      // width: 4.2rem;
    }
  }

  .menu-ul {
    width: 100%;
    background-color: rgba($color: #000000, $alpha: 0.82);
    border-radius: 18px;
    padding: 18px 0;

    .menu-item {
      width: 100%;
      height: 61px;
      padding: 0 30px;
      text-align: left;
      color: #ffffff;
      font-size: 22px;
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      justify-items: flex-start;

      &.hasChild::after {
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #ffffff;
        vertical-align: middle;
        display: inline-block;
        position: absolute;
        right: 30px;
        top: 50%;
        margin-top: -5px;
      }

      .icon {
        width: 18px;
        height: 21px;
        @include background-com();
        display: inline-block;
        margin-right: 10px;

        &.icon-building {
          background-image: url("../assets/img/icon-building.png");
        }

        &.icon-huangguan {
          background-image: url("../assets/img/icon-huangguan.png");
        }

        &.icon-circle {
          background-image: url("../assets/img/icon-circle.png");
        }

        &.icon-house {
          background-image: url("../assets/img/icon-house.png");
        }

        &.icon-future {
          background-image: url("../assets/img/icon-future.png");
        }
        &.icon-hudong {
          background-image: url("../assets/img/icon-hudong.png");
        }
      }

      &:hover {
        background-color: #444444;
        color: #df8903;

        .menu-child-ul {
          display: block;
        }

        .menu-child-ul2 {
          display: block;
        }

        .icon {

          &.icon-building {
            background-image: url("../assets/img/icon-building-active.png");
          }

          &.icon-huangguan {
            background-image: url("../assets/img/icon-huangguan-active.png");
          }

          &.icon-circle {
            background-image: url("../assets/img/icon-circle-active.png");
          }

          &.icon-house {
            background-image: url("../assets/img/icon-house-active.png");
          }

          &.icon-future {
            background-image: url("../assets/img/icon-future-active.png");
          }
          &.icon-hudong {
          background-image: url("../assets/img/icon-hudong-active.png");
        }
        }
      }

      &.active {
        color: #df8903;

        .icon {

          &.icon-building {
            background-image: url("../assets/img/icon-building-active.png");
          }

          &.icon-huangguan {
            background-image: url("../assets/img/icon-huangguan-active.png");
          }

          &.icon-circle {
            background-image: url("../assets/img/icon-circle-active.png");
          }

          &.icon-house {
            background-image: url("../assets/img/icon-house-active.png");
          }

          &.icon-future {
            background-image: url("../assets/img/icon-future-active.png");
          }
          &.icon-hudong {
          background-image: url("../assets/img/icon-hudong-active.png");
        }
        }
      }



      .menu-child-ul {
        width: 870px;
        // height: 550px;
        position: absolute;
        display: none;
        overflow: hidden;
        top: 0;
        left: 100%;
        padding-top: 28px;
        padding-bottom: 28px;
        background-color: rgba($color: #212121, $alpha: 0.92);
        border-top-right-radius: 28px;
        border-bottom-right-radius: 28px;
        border-bottom-left-radius: 28px;
        z-index: 10000;

        .menu-child-li {
          width: 100%;
          padding: 0 28px;
          height: 45px;
          line-height: 45px;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          font-size: 20px;
          text-align: left;

          &:hover {
            background-color: #444444;

          }

          &.active {
            color: #df8903;
          }
        }


      }

      .menu-child-ul2 {
        width: 447px;
        min-height: 420px;
        position: absolute;
        display: none;
        overflow: hidden;
        top: 0;
        left: 100%;
        padding-top: 28px;
        padding-bottom: 28px;
        background-color: rgba($color: #212121, $alpha: 0.8);
        border-top-right-radius: 28px;
        border-bottom-right-radius: 28px;
        border-bottom-left-radius: 28px;
        z-index: 10000;

        .menu-child-col {
          position: relative;

          &::after {
            width: 2px;
            display: block;
            background-color: #ffffff;
            height: 100%;
            content: "";
            position: absolute;
            right: 0;
            top: 0;
          }

          &:last-child {
            &::after {
              display: none;
            }
          }

          .menu-child-li2:last-child {
            margin-bottom: 0;
          }
        }

        .menu-child-li2 {
          width: 100%;
          padding: 0 25px;

          display: inline-block;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          font-size: 20px;
          text-align: justify;
          text-justify: distribute-all-lines;
          text-align-last: justify;
          margin-bottom: 16px;
          vertical-align: top;

          &:hover {
            background-color: #444444;

          }

          &.active {
            color: #df8903;
          }
        }
      }
    }

    // .menu-up {
    //   width: 0.3rem;
    //   height: 0.14rem;
    //   background-image: url("../assets/img/menu-up.png");
    //   @include background-com();
    //   position: absolute;
    //   left: 50%;
    //   margin-left: -0.15rem;
    //   bottom: 0.3rem;
    //   cursor: pointer;
    //   &:hover {
    //     background-image: url("../assets/img/menu-up-hover.png");
    //   }
    // }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

